let fileUpload;
function onDocumentReady() {
    fileUpload = $('.gform_fileupload_multifile');
    fileUpload.each(function(){
        $(this).find('.gform_drop_instructions').text('Drop a file here or click to upload');
    });
}


$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/form-controller.js